export default function SvgDelete() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1264_8503)">
        <path
          d="M8.5 0.5C4.08173 0.5 0.5 4.08173 0.5 8.5C0.5 12.9183 4.08173 16.5 8.5 16.5C12.9183 16.5 16.5 12.9183 16.5 8.5C16.5 4.08173 12.9183 0.5 8.5 0.5ZM11.2052 9.96855C11.5467 10.3101 11.5467 10.8637 11.2052 11.2052C11.0344 11.376 10.8107 11.4613 10.5869 11.4613C10.3631 11.4613 10.1393 11.376 9.96855 11.2052L8.5 9.73667L7.03149 11.2052C6.86075 11.376 6.63696 11.4613 6.41317 11.4613C6.18938 11.4613 5.96559 11.376 5.79485 11.2052C5.45334 10.8637 5.45334 10.3101 5.79485 9.96855L7.2634 8.5L5.79485 7.03145C5.45334 6.68994 5.45334 6.13629 5.79485 5.79478C6.13636 5.45327 6.69001 5.45327 7.03152 5.79478L8.50004 7.26333L9.96855 5.79478C10.3101 5.45327 10.8637 5.45327 11.2052 5.79478C11.5467 6.13625 11.5467 6.68994 11.2052 7.03145L9.73664 8.5L11.2052 9.96855Z"
          fill="#CEB2E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1264_8503">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
